export default __webpack_public_path__ + "static/media/background_1.d9483e3d.jpg";